import { FC, useState } from 'react';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Chip,
	Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
	ApiViewLevel,
	HttpMethods,
	Section,
} from '../../../lib/interfaces/ApiControl';
import ApiControlEndpoint from './ApiControlEndpoint';
import ContentTitleSimple from '../../Simple/ContentTitle/ContentTitleSimple';
import ContentRenderer from '../Content/ContentRenderer';
import { RootState } from '../../../redux/store';

type ApiControlSectionProps = {
	section: Section;
	mode: ApiViewLevel;
};

const colorByMethodDict = {
	[HttpMethods.GET]: '#205614',
	[HttpMethods.POST]: '#979230',
	[HttpMethods.PUT]: '#fba030',
	[HttpMethods.PATCH]: '#5f2e79',
	[HttpMethods.DELETE]: '#791e1e',
	[HttpMethods.WS]: '#a56de1',
};

// const colorByMethodDict = {
// 	[HttpMethods.GET]: '#444',
// 	[HttpMethods.POST]: '#444',
// 	[HttpMethods.PUT]: '#444',
// 	[HttpMethods.PATCH]: '#444',
// 	[HttpMethods.DELETE]: '#444',
// 	[HttpMethods.WS]: '#444',
// };

const ApiControlSection: FC<ApiControlSectionProps> = ({ section, mode }) => {
	const getColorByMethod = (method: HttpMethods) => colorByMethodDict[method];
	const { isDarkTheme } = useSelector((state: RootState) => state.ui.theme);
	const [expanded, setExpanded] = useState<string[]>(
		mode === ApiViewLevel.API ? [section.apiItems[0].id] : [],
	);

	const handleChange = (id: string) => {
		if (expanded.includes(id)) {
			setExpanded(expanded.filter((item) => item !== id));
		} else {
			setExpanded([...expanded, id]);
		}
	};
	return (
		<div style={{ marginBottom: '30px' }}>
			{mode !== ApiViewLevel.API && (
				<ContentTitleSimple id={section.id} title={section.title} noDivider />
			)}
			{mode !== ApiViewLevel.API && <ContentRenderer html={section.description} />}
			<div style={{ marginTop: '10px' }}>
				{section.apiItems.map((item) => (
					<Accordion
						expanded={expanded.includes(item.id)}
						onChange={() => handleChange(item.id)}
						elevation={0}
						sx={{
							marginTop: '-2px',
							'&.Mui-expanded': {
								margin: 0,
								marginTop: '-2px',
							},
							'&::before': {
								opacity: 0,
							},
							border: (theme) =>
								`2px solid ${theme.palette.grey[isDarkTheme ? 800 : 200]}`,
						}}
					>
						<AccordionSummary
							expandIcon={
								<ExpandMoreIcon
									style={{
										color: !isDarkTheme
											? 'rgba(0, 0, 0, 0.54)'
											: 'rgba(255, 255, 255, 0.54)',
									}}
								/>
							}
							aria-controls="panel1-content"
							id={item.id}
						>
							<div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
								<Chip
									label={item.method.toUpperCase()}
									size="small"
									style={{
										background: getColorByMethod(item.method),
										color: '#fff',
										fontWeight: 500,
									}}
								/>

								<Typography sx={{ fontWeight: '500' }}>{item.title}</Typography>
							</div>
						</AccordionSummary>
						<AccordionDetails>
							<ApiControlEndpoint apiItem={item} />
						</AccordionDetails>
					</Accordion>
				))}
			</div>
		</div>
	);
};

export default ApiControlSection;
